var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"loading-spinner"},_vm._l((_vm.circles),function(item,index){return _c('circle',{key:index,attrs:{"cx":_vm.circlePositions[index] && _vm.circlePositions[index].x,"cy":_vm.circlePositions[index] && _vm.circlePositions[index].y,"r":item.radius,"fill":item.color}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c101504","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/LoaderAnim.vue
// module id = null
// module chunks = 